import { createAsyncAction } from 'react-redux-await-control';
import { message } from 'antd';

import { backoffice } from '~/services';
import { handleErrors } from '~/common/utils/errorHandler';

// Debt

export const getDividaByContractId = createAsyncAction('COBRANCA_GET_DIVIDA_BY_CONTRACT_ID', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    errorParser: () => null,
    onRequestError: (err) =>
      handleErrors(err, {
        defaultMessage: 'Erro ao consultar parcelas em atraso',
        ignoreErrorStatus: [404],
      }),
    request: ({ contractId }) => backoffice.get(`/billing/contracts/${contractId}/debt`),
  },
});

export const getDivida = createAsyncAction('COBRANCA_GET_DIVIDA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar dívida'),
    request: ({ codigoCredor, codigoCliente }) => backoffice.get(`/billing/debt/${codigoCredor}/${codigoCliente}`),
  },
});

// Offer

export const getOfertaOpcoesPagamento = createAsyncAction('COBRANCA_GET_OFERTA_OPCOES_PAGAMENTO', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar opções de pagamento da oferta'),
    request: ({ codigoCredor, codigoCliente, codigoSolicitacao }) =>
      backoffice.get(`/billing/offer/${codigoCredor}/${codigoCliente}/${codigoSolicitacao}`),
  },
});

export const getOfertaStatus = createAsyncAction('COBRANCA_GET_OFERTA_STATUS', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar status da oferta'),
    request: ({ codigoCredor, codigoCliente, codigoSolicitacao }) =>
      backoffice.get(`/billing/offer/${codigoCredor}/${codigoCliente}/${codigoSolicitacao}/status`),
  },
});

export const solicitarOferta = createAsyncAction('COBRANCA_SOLICITAR_OFERTA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Oferta solicitada com sucesso!'),
    onRequestError: () => message.error('Erro ao solicitar oferta'),
    request: (payload) => backoffice.post('/billing/offer/request', payload),
  },
});

export const confirmarOferta = createAsyncAction('COBRANCA_CONFIRMAR_OFERTA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Oferta confirmada com sucesso!'),
    onRequestError: () => message.error('Erro ao confirmar oferta'),
    request: (payload) => backoffice.post('/billing/offer/confirm', payload),
  },
});

// Occurrence

export const registrarOcorrencia = createAsyncAction('COBRANCA_REGISTRAR_OCORRENCIA', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Ocorrência registrada com sucesso!'),
    onRequestError: () => message.error('Erro ao registrar ocorrência'),
    request: (payload) => backoffice.post('/billing/occurrence', payload),
  },
});

export const alegaPagamento = createAsyncAction('COBRANCA_ALEGA_PAGAMENTO', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Alegação de pagamento registrada com sucesso!'),
    onRequestError: () => message.error('Erro ao registrar alegação de pagamento'),
    request: (payload) => backoffice.post('/billing/occurrence/claims-payment', payload),
  },
});

export const desconheceDivida = createAsyncAction('COBRANCA_DESCONHECE_DIVIDA', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Desconhecimento de dívida registrado com sucesso!'),
    onRequestError: () => message.error('Erro ao registrar desconhecimento de dívida'),
    request: (payload) => backoffice.post('/billing/occurrence/disputes-debt', payload),
  },
});

// Pix

export const emitirPix = createAsyncAction('COBRANCA_EMITIR_PIX', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix'),
    request: (payload) => backoffice.post('/billing/pix', payload),
  },
});

export const emitirPixPorContrato = createAsyncAction('COBRANCA_EMITIR_PIX_POR_CONTRATO', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix'),
    request: ({ contractId, ...payload }) => backoffice.post(`/billing/contracts/${contractId}/pix`, payload),
  },
});

export const getTicketsCobranca = createAsyncAction('COBRANCA_GET_TICKETS', {
  saveResult: true,
  initialValue: [],
  context: {
    responseParser: ({ data }) => data?.tickets || [],
    onRequestError: () => message.error('Erro ao consultar tickets de cobrança'),
    request: ({ personId, contractId }) =>
      backoffice.get('/tickets', {
        params: {
          personId,
          contractId,
          status: 'Aguardando tratativa',
          journey: 'Cobrança',
          canListTicket: true,
        },
      }),
  },
});

export const emitirPixParcelamento = createAsyncAction('COBRANCA_EMITIR_PIX_PARCELAMENTO', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix de parcelamento emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix de parcelamento'),
    request: (payload) => backoffice.post('/billing/pix', payload),
  },
});

export const emitirPixPdf = createAsyncAction('COBRANCA_EMITIR_PIX_PDF', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix PDF emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix PDF'),
    request: (payload) => backoffice.post('/billing/pix/pdf', payload),
  },
});

export const emitirPixSms = createAsyncAction('COBRANCA_EMITIR_PIX_SMS', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix enviado por SMS com sucesso!'),
    onRequestError: () => message.error('Erro ao enviar Pix por SMS'),
    request: (payload) => backoffice.post('/billing/pix/sms', payload),
  },
});

export const emitirPixEmail = createAsyncAction('COBRANCA_EMITIR_PIX_EMAIL', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix enviado por e-mail com sucesso!'),
    onRequestError: () => message.error('Erro ao enviar Pix por e-mail'),
    request: (payload) => backoffice.post('/billing/pix/email', payload),
  },
});

export const emitirPixOriginal = createAsyncAction('COBRANCA_EMITIR_PIX_ORIGINAL', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix original emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix original'),
    request: (payload) => backoffice.post('/billing/pix/original', payload),
  },
});

export const emitirPixOriginalPdf = createAsyncAction('COBRANCA_EMITIR_PIX_ORIGINAL_PDF', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Pix original PDF emitido com sucesso!'),
    onRequestError: () => message.error('Erro ao emitir Pix original PDF'),
    request: (payload) => backoffice.post('/billing/pix/original/pdf', payload),
  },
});

// Installment plan

export const getParcelamento = createAsyncAction('COBRANCA_GET_PARCELAMENTO', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar parcelamentos'),
    request: ({ codigoCredor, codigoCliente }) =>
      backoffice.get(`/billing/installment/${codigoCredor}/${codigoCliente}`),
  },
});

export const cancelarParcelamento = createAsyncAction('COBRANCA_CANCELAR_PARCELAMENTO', {
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Parcelamento cancelado com sucesso!'),
    onRequestError: () => message.error('Erro ao cancelar parcelamento'),
    request: ({ codigoCredor, codigoCliente, codigoParcelamento }) =>
      backoffice.delete(`/billing/installment/${codigoCredor}/${codigoCliente}/${codigoParcelamento}`),
  },
});

// Proposal

export const getPropostaStatus = createAsyncAction('COBRANCA_GET_PROPOSTA_STATUS', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar status da proposta'),
    request: ({ codigoCredor, codigoCliente, codigoProposta }) =>
      backoffice.get(`/billing/proposal/${codigoCredor}/${codigoCliente}/${codigoProposta}/status`),
  },
});

export const getProposta = createAsyncAction('COBRANCA_GET_PROPOSTA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestError: () => message.error('Erro ao consultar proposta'),
    request: ({ codigoCredor, codigoCliente, codigoProposta }) =>
      backoffice.get(`/billing/proposal/${codigoCredor}/${codigoCliente}/${codigoProposta}`),
  },
});

export const solicitarProposta = createAsyncAction('COBRANCA_SOLICITAR_PROPOSTA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Proposta solicitada com sucesso!'),
    onRequestError: () => message.error('Erro ao solicitar proposta'),
    request: (payload) => backoffice.post('/billing/proposal/request', payload),
  },
});

export const confirmarProposta = createAsyncAction('COBRANCA_CONFIRMAR_PROPOSTA', {
  saveResult: true,
  initialValue: null,
  context: {
    responseParser: ({ data }) => data,
    onRequestSuccess: () => message.success('Proposta confirmada com sucesso!'),
    onRequestError: () => message.error('Erro ao confirmar proposta'),
    request: (payload) => backoffice.post('/billing/proposal/confirm', payload),
  },
});
